import {PortalModule} from '@angular/cdk/portal';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {LOCALE_ID, NgModule} from '@angular/core';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonModule } from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatRippleModule, MAT_DATE_LOCALE, MAT_RIPPLE_GLOBAL_OPTIONS, DateAdapter, NativeDateAdapter } from '@angular/material/core';
import {MatNativeDateModule} from '@angular/material/core';
import {MatDatepickerModule, MatCalendar} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSelectModule} from '@angular/material/select';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatChipsModule} from '@angular/material/chips';
import {MatMenuModule} from '@angular/material/menu';
import { MdePopoverModule } from '@carm/shared/material-extended/mde/src/lib/popover';
import * as dayjs from 'dayjs';
import { MatFormFieldModule } from '@angular/material/form-field';

export class DayJSDateAdapter extends NativeDateAdapter {
  parse(value: string): Date | null {
    return value ?  new Date(value && value.length <= 10 ? value + " 00:00:00" : value) : null;
  }

  format(date: Date): string {
    return dayjs.utc(date).format('YYYY-MM-DD')
  }
}

@NgModule({
  imports: [
    CdkStepperModule,
    MatBottomSheetModule,
    MatStepperModule,
    MatExpansionModule,
    MatIconModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatRippleModule,
    MatSelectModule,
    MatButtonModule,
    MatSnackBarModule,
    MatDialogModule,
    MatSortModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    PortalModule,
    ScrollingModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    MdePopoverModule,
    MatCardModule,
    MatSlideToggleModule,
    MatPaginatorModule,
    MatChipsModule,
    MatMenuModule,
    MatFormFieldModule
  ],
  exports: [
    CdkStepperModule,
    MatBottomSheetModule,
    MatStepperModule,
    MatExpansionModule,
    MatIconModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatRippleModule,
    MatSelectModule,
    MatButtonModule,
    MatSnackBarModule,
    MatDialogModule,
    MatSortModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    PortalModule,
    ScrollingModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    MdePopoverModule,
    MatCardModule,
    MatSlideToggleModule,
    MatChipsModule,
    MatMenuModule,
    MatFormFieldModule
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useFactory: (localeId) => localeId, deps: [LOCALE_ID]},
    {
      provide: DateAdapter,
      useClass: DayJSDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS,
      useValue: {
        disabled: true,
        animation: { enterDuration: 0, exitDuration: 0 }
      }
    },
    MatCalendar
  ]
})

export class AngularMaterialModule {
}
